export default {
  props: {
    /**
     * `{ sources: [], src: '', alt: '', imgClass: '', lazy: '' }`
     */
    image: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      required: true,
    },
    address: {
      type: String,
      required: true,
    },
    productCategories: {
      type: Array,
      default: () => [],
    },
    status: {
      type: String,
      default: '',
    },
    /**
     * Store phone number
     */
    phone: {
      type: String,
      default: '',
    },
    /**
     * Text displayed on the call button. Fallback to the "phone" value.
     */
    phoneLabel: {
      type: String,
      default: '',
    },
    /**
     * The boutique page URL
     */
    permalink: {
      type: String,
      default: '',
    },
    tracking: {
      type: Object,
      default: null,
    },
    seeMoreLabel: {
      type: String,
      required: true,
    },
    isOnline: {
      type: Boolean,
      default: false,
    },
    additionalProps: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    isRepairer: {
      type: Boolean,
      default: false,
      required: false,
    },
    isReseller: {
      type: Boolean,
      default: false,
      required: false,
    },
    dataTracking: {
      type: Object,
      default: null,
    },
    distance: {
      type: [String, Number],
      required: false,
    },
  },

  computed: {
    btqquickcallTrackingEnabled() {
      return this.tracking && this.tracking.btqquickcall;
    },
    seebtqTrackingEnabled() {
      return this.tracking && this.tracking.seebtq;
    },
    hasDistance() {
      return this.distance !== undefined;
    },
  },
};
